export default __webpack_public_path__ + "static/media/collect-data.34bb7c75.svg";